"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _colors = require("HubStyleTokens/colors");

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _ItemConfigsSelectors = require("../../selectors/ItemConfigsSelectors");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-weight: 600;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: inline;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: center !important;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: right;\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-decoration: line-through;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-decoration: line-through;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 500;\n  padding: 1px 0 2px 8px;\n  line-height: initial;\n  display: inline-block;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  line-height: initial;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  padding-left: 7px;\n  padding-right: 7px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 500;\n  line-height: initial;\n  padding: 1px 0 2px 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FullPriceContainerBase = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__FullPriceContainerBase",
  componentId: "sainix-0"
})(_templateObject(), _colors.PANTERA);

var FullPriceContainerBlock = (0, _styledComponents.default)(FullPriceContainerBase).withConfig({
  displayName: "HighlightedMerchPriceDisplay__FullPriceContainerBlock",
  componentId: "sainix-1"
})(_templateObject2());
var FullPriceContainerInline = (0, _styledComponents.default)(FullPriceContainerBase).withConfig({
  displayName: "HighlightedMerchPriceDisplay__FullPriceContainerInline",
  componentId: "sainix-2"
})(_templateObject3());

var PriceContainer = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__PriceContainer",
  componentId: "sainix-3"
})(_templateObject4());

var DiscountedPriceContainer = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__DiscountedPriceContainer",
  componentId: "sainix-4"
})(_templateObject5(), _colors.OZ);

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "HighlightedMerchPriceDisplay__CrossedOutPrice",
  componentId: "sainix-5"
})(_templateObject6());
var CrossedOutSubtextPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "HighlightedMerchPriceDisplay__CrossedOutSubtextPrice",
  componentId: "sainix-6"
})(_templateObject7());

var PriceSection = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchPriceDisplay__PriceSection",
  componentId: "sainix-7"
})(_templateObject8(), _responsiveBreakpoints.default.tablet(_templateObject9()));

var MicroCopy = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "HighlightedMerchPriceDisplay__MicroCopy",
  componentId: "sainix-8"
})(_templateObject10(), _responsiveBreakpoints.default.tablet(_templateObject11()));

var Bold = _styledComponents.default.span.withConfig({
  displayName: "HighlightedMerchPriceDisplay__Bold",
  componentId: "sainix-9"
})(_templateObject12(), _colors.PANTERA);

var StyledAsterisk = (0, _styledComponents.default)(MicroCopy).withConfig({
  displayName: "HighlightedMerchPriceDisplay__StyledAsterisk",
  componentId: "sainix-10"
})(_templateObject13());

var HighlightedMerchPriceDisplay = function HighlightedMerchPriceDisplay(_ref) {
  var merchandiseId = _ref.merchandiseId,
      activeCurrencyCode = _ref.activeCurrencyCode,
      pricingInfo = _ref.pricingInfo,
      showDiscountedPricing = _ref.showDiscountedPricing,
      inlinePriceDisplay = _ref.inlinePriceDisplay,
      _ref$showPriceAsteris = _ref.showPriceAsterisk,
      showPriceAsterisk = _ref$showPriceAsteris === void 0 ? false : _ref$showPriceAsteris,
      availableTerms = _ref.availableTerms,
      activeTerm = _ref.activeTerm;
  var _pricingInfo$monthly = pricingInfo.monthly,
      monthlyFullPrice = _pricingInfo$monthly.fullPrice,
      monthlyCalculatedPrice = _pricingInfo$monthly.calculatedPrice,
      _pricingInfo$annually = pricingInfo.annually,
      annualFullPrice = _pricingInfo$annually.fullPrice,
      annualCalculatedPrice = _pricingInfo$annually.calculatedPrice;
  var annualOnly = !availableTerms.monthly;
  var PriceContainerComponent = inlinePriceDisplay ? FullPriceContainerInline : FullPriceContainerBlock;
  var discountedKey = activeTerm === Terms.MONTHLY ? 'discountedPricingPerMonthBilledMonthly_jsx' : 'discountedPricingPerYearAtCost_jsx';
  var normalKey = annualOnly ? 'pricingPerYearAtCost_jsx' : 'pricingPerMonthBilledMonthly_jsx';
  return _react.default.createElement(PriceSection, {
    style: {
      textAlign: inlinePriceDisplay ? 'left' : null
    },
    className: inlinePriceDisplay ? 'm-top-5' : null
  }, showDiscountedPricing ? _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage." + discountedKey,
    options: {
      currencyCode: activeCurrencyCode,
      fullPrice: monthlyFullPrice,
      discountedPrice: monthlyCalculatedPrice,
      merchandiseId: merchandiseId,
      annualFullPrice: annualFullPrice,
      annualDiscountedPrice: annualCalculatedPrice
    },
    elements: {
      MicroCopy: MicroCopy,
      DiscountedPriceContainer: DiscountedPriceContainer,
      CrossedOutPrice: CrossedOutPrice,
      CrossedOutSubtextPrice: CrossedOutSubtextPrice,
      PriceDisplay: _PriceDisplay.default,
      Bold: Bold,
      PriceContainer: PriceContainer
    }
  }) : _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage." + normalKey,
    options: {
      currencyCode: activeCurrencyCode,
      price: monthlyCalculatedPrice,
      annualPrice: annualCalculatedPrice,
      merchandiseId: merchandiseId
    },
    elements: {
      MicroCopy: inlinePriceDisplay ? _Small.default : MicroCopy,
      PriceContainer: PriceContainerComponent,
      PriceDisplay: _PriceDisplay.default,
      Bold: Bold
    }
  }), showPriceAsterisk && _react.default.createElement(StyledAsterisk, {
    use: "help"
  }, '*'));
};

HighlightedMerchPriceDisplay.propTypes = {
  pricingInfo: _propTypes.default.object.isRequired,
  activeCurrencyCode: _propTypes.default.string.isRequired,
  showDiscountedPricing: _propTypes.default.bool.isRequired,
  inlinePriceDisplay: _propTypes.default.bool,
  merchandiseId: _propTypes.default.number.isRequired,
  showPriceAsterisk: _propTypes.default.bool,
  availableTerms: _propTypes.default.object,
  activeTerm: _propTypes.default.oneOf(Object.values(Terms)).isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId,
      activeTerm = _ref2.activeTerm,
      _ref2$additionalUnitQ = _ref2.additionalUnitQuantity,
      additionalUnitQuantity = _ref2$additionalUnitQ === void 0 ? 0 : _ref2$additionalUnitQ;
  var availableTerms = (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId);
  return {
    pricingInfo: (0, _PricingSelectors.getCalculatePriceAndItemConfigSelector)(state)({
      merchandiseId: merchandiseId,
      term: activeTerm,
      additionalUnitQuantity: additionalUnitQuantity
    }),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    showDiscountedPricing: (0, _PromotionSelectors.showDiscountedPricingSelector)(state, merchandiseId, (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTerms)),
    availableTerms: availableTerms
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HighlightedMerchPriceDisplay);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/HighlightedMerchPriceDisplay.js
// module id = 488
// module chunks = 5 6